import { promptService } from '@/services/promptService';
import { Prompt, PromptUpdate } from '@/types';
import { atom } from 'jotai';
import { toast } from 'sonner';

export const promptsAtom = atom<Prompt[]>([]);
export const promptsLoadingAtom = atom<boolean>(false);

export const fetchPromptsActionAtom = atom(null, async (_, set) => {
  set(promptsLoadingAtom, true);
  try {
    const response = await promptService.getPrompts();
    set(promptsAtom, response);
  } catch (error) {
    toast.error('Failed to fetch prompts');
    console.error('Failed to fetch prompts:', error);
  } finally {
    set(promptsLoadingAtom, false);
  }
});

export const updatePromptsActionAtom = atom(
  null,
  async (
    _,
    set,
    { promptId, payload }: { promptId: string; payload: PromptUpdate }
  ) => {
    set(promptsLoadingAtom, true);
    try {
      const response = await promptService.updatePrompt(promptId, payload);
      set(promptsAtom, current =>
        current.map(prompt => (prompt.id === response.id ? response : prompt))
      );
      toast.success('Prompts updated successfully');
    } catch (error) {
      toast.error('Failed to update prompts');
      console.error('Failed to update prompts:', error);
    } finally {
      set(promptsLoadingAtom, false);
    }
  }
);

export const resetPromptActionAtom = atom(
  null,
  async (_, set, promptId: string) => {
    set(promptsLoadingAtom, true);
    try {
      const response = await promptService.resetPrompt(promptId);
      set(promptsAtom, current =>
        current.map(prompt => (prompt.id === response.id ? response : prompt))
      );
      toast.success('Prompt reset successfully');
    } catch (error) {
      toast.error('Failed to reset prompt');
      console.error('Failed to reset prompt:', error);
    } finally {
      set(promptsLoadingAtom, false);
    }
  }
);
